import axios from "axios";
import Cookies from "universal-cookie";
import { backendUrl } from "../utils/url";

const cookies = new Cookies();

const api = axios.create({
  baseURL: backendUrl,
  timeout: 5000,
  headers: {
    "Content-Type": "application/json",
    Authorization: `Bearer ${cookies.get("jwt-auth")}`,
  },
});

export const deleteTemplate = async (id) => {
  try {
    const res = await api.delete("/template/" + id);
    return res;
  } catch (err) {
    return err.response;
  }
};

export const getAllTemplates = async () => {
  try {
    const res = await api.get("/template/all");
    return res;
  } catch (err) {
    return err.response;
  }
};

export const addTemplate = async (formData) => {
  try {
    const token = cookies.get("jwt-auth");
    const response = await axios.post(
      backendUrl + "/template/create",
      formData,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      },
    );
    return response;
  } catch (err) {
    return err.response;
  }
};

export const uploadTemplateImage = async (formData) => {
  try {
    const token = cookies.get("jwt-auth");
    const response = await axios.post(
      backendUrl + "/upload/template",
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      },
    );
    return response;
  } catch (err) {
    return err.response;
  }
};
